













































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { MyChannel } from "@/services/apiService/api.types";
import apiService from "@/services/apiService/apiService";
import { Action, Getter, Mutation } from "vuex-class";
import { AlertAction, AlertState, AlertType } from "@/components/alert/types";
import { Namespace } from "@/store/types";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import {
  ChannelsPageGetter,
  ChannelsPageMutation,
  InfoChannelData,
  ViewType
} from "@/components/channelsPage/types";
import { RouteName } from "@/router/types";
import {
  ChannelChangeAction,
  ChannelChangeMutation
} from "@/components/channelChange/types";
import { OverlayAction } from "@/components/overlay/types";
import { digitCount } from "@/helpers/utils";
import { Categories } from "@/helpers/constants";
import { EventBus } from "@/main";
import LockIcon from "@/assets/svg/svg-settings/LockIcon.vue";
import { LocaleChannelsPageChannelCard } from "@/plugins/i18n/types";

@Component({
  components: { LockIcon }
})
export default class ChannelCard extends Vue {
  @Prop() readonly channel?: MyChannel;
  @Prop() readonly channelIndex?: number;
  @Prop() readonly channelCategory?: Categories;
  @Prop() readonly channelView?: ViewType;

  @Action(AlertAction.UpdateAlert, { namespace: Namespace.Alert })
  newAlert!: (ChannelChangeGetter: AlertState) => Promise<void>;

  @Action(ChannelChangeAction.UpdateSource, {
    namespace: Namespace.ChannelChange
  })
  updateSource!: (src: string) => void;

  @Action(ChannelChangeAction.UpdateOffset, {
    namespace: Namespace.ChannelChange
  })
  updateOffset!: (offset: number) => void;

  @Action(OverlayAction.UpdateChannelEpg, {
    namespace: Namespace.Overlay
  })
  updateChannelEpg!: () => Promise<void>;

  @Mutation(ChannelsPageMutation.setCardControls, {
    namespace: Namespace.ChannelsPage
  })
  setControlsActive!: (cardControls: boolean) => void;

  @Mutation(ChannelChangeMutation.SetChannelId, {
    namespace: Namespace.ChannelChange
  })
  setChannelId!: (channelId: number) => void;

  @Mutation(ChannelsPageMutation.setPlayedChannelIndex, {
    namespace: Namespace.ChannelsPage
  })
  setPlayedChannelIndex!: (index?: number) => void;

  @Mutation(ChannelsPageMutation.setPlayedChannelCategory, {
    namespace: Namespace.ChannelsPage
  })
  setPlayedChannelCategory!: (category?: Categories) => void;

  @Mutation(ChannelsPageMutation.setPlayedChannelView, {
    namespace: Namespace.ChannelsPage
  })
  setPlayedChannelView!: (channelView?: ViewType) => void;

  @Getter(ChannelsPageGetter.GetCardControls, {
    namespace: Namespace.ChannelsPage
  })
  getCardControlsStatus!: boolean;

  @Mutation(ChannelsPageMutation.setPlayedChannelId, {
    namespace: Namespace.ChannelsPage
  })
  setPlayedChannelId!: (channelId?: number) => void;

  @Mutation(ChannelsPageMutation.setShowEpgScreen, {
    namespace: Namespace.ChannelsPage
  })
  setShowEpgScreen!: () => void;

  @Mutation(ChannelsPageMutation.setActiveChannelOverlayInfo, {
    namespace: Namespace.ChannelsPage
  })
  setActiveChannelOverlayInfo!: (channelInfo?: InfoChannelData) => void;

  @Getter(ChannelsPageGetter.GetPlayedChannelId, {
    namespace: Namespace.ChannelsPage
  })
  getPlayedChannelId!: number | undefined;

  @Getter(ChannelsPageGetter.getShowEpgScreen, {
    namespace: Namespace.ChannelsPage
  })
  getShowEpgScreen!: boolean;

  @Getter(ChannelsPageGetter.getShowInfoScreen, {
    namespace: Namespace.ChannelsPage
  })
  getShowInfoScreen!: boolean;

  showControls = false;
  focusedControl = 0;

  card: HTMLElement | null = null; //var that stores reference to this card in the DOM

  LocaleChannelsPageChannelCard = LocaleChannelsPageChannelCard;

  mounted(): void {
    this.card = document.getElementById("channel" + this.channel?.id);
    if (this.card) {
      this.card.addEventListener("focusout", this.focusChanged);
    }

    //focusing previously played channel and setting the data required
    if (
      this.getPlayedChannelId &&
      this.getPlayedChannelId === this.channel?.id &&
      !this.getShowEpgScreen &&
      !this.getShowInfoScreen
    ) {
      SpatialNavigation.focus("#channel" + this.channel.id);
      this.setControlsActive(false);
      this.setPlayedChannelId();
      this.setPlayedChannelIndex();
      this.setPlayedChannelCategory();
      this.setPlayedChannelView();
    }

    //plays focused channel if overlay play btn was triggered(more convenient then copying play channel logic to every overlay)
    EventBus.$on("playChannel", (channelId: number) => {
      if (this.channel && this.channel.id === channelId) {
        this.playChannel();
      }
    });
  }

  get channelNum(): string {
    let channelNum = "";
    if (this.channel) {
      for (let i = 0; i < 3 - digitCount(this.channel?.id); i++) {
        channelNum += "0";
      }
      return channelNum + this.channel.id + ".";
    }

    return "000";
  }

  get epgIcon(): string {
    return require("/src/assets/svg/svg-home/09-epg.svg");
  }

  get addFavIcon(): string {
    return require("/src/assets/svg/svg-home/11-add-fav.svg");
  }

  get favIcon(): string {
    return require("/src/assets/svg/svg-home/12-fav.svg");
  }

  async handleFavourite(): Promise<void> {
    try {
      if (this.channel && !this.channel?.isFavorite) {
        await apiService.setChannelAsFavourite(this.channel.id);
      }
      if (this.channel && this.channel?.isFavorite) {
        await apiService.removeChannelAsFavourite(this.channel.id);
      }
      this.$emit("channelUpdate", this.channel ? this.channel?.id : "");
    } catch (err) {
      const alertInfo: AlertState = {
        show: true,
        message: err.message,
        alertType: AlertType.Danger
      };
      await this.newAlert(alertInfo);
    }
  }

  openEpgModal(): void {
    if (this.channel) {
      const channelInfo: InfoChannelData = {
        channelName: this.channel.name,
        channelId: this.channel.id,
        channelCatchup: !!this.channel.catchup
      };

      this.setActiveChannelOverlayInfo(channelInfo);
      this.setShowEpgScreen();
    }
  }

  handleCardControls(event: KeyboardEvent): void {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_ENTER:
        if (!this.showControls) {
          this.openControls();
          return;
        }
        switch (this.focusedControl) {
          case 0:
            this.playChannel();
            break;
          case 1:
            this.openEpgModal();
            break;
          case 2:
            this.handleFavourite();
            break;
        }
        break;
      case KeySet.KEY_RIGHT:
        if (this.focusedControl < 2) {
          this.focusedControl++;
        }
        break;
      case KeySet.KEY_LEFT:
        if (this.focusedControl > 0) {
          this.focusedControl--;
        }
        break;
      case KeySet.KEY_BACK:
        this.showControls = false;
        this.setControlsActive(false);
        SpatialNavigation.resume();
        break;
    }
  }

  openControls(): void {
    this.showControls = true;
    this.setControlsActive(true);
  }

  focusChanged(): void {
    if (document.activeElement?.id !== "channel" + this.channel?.id) {
      this.showControls = false;
    }
  }

  async playChannel(): Promise<void> {
    if (this.channel) {
      //setting player and overlay required info
      this.updateSource(this.channel.videoLive);
      this.setChannelId(this.channel.id);
      this.updateOffset(0);
      await this.updateChannelEpg();

      //used upon component load to focus defined channels card if one is set
      this.setPlayedChannelId(this.channel.id);
      this.setPlayedChannelIndex(this.channelIndex);
      this.setPlayedChannelCategory(this.channelCategory);
      this.setPlayedChannelView(this.channelView);

      await this.$router.push({ name: RouteName.Player });
    }
  }

  beforeDestroy(): void {
    if (this.card) {
      this.card.removeEventListener("focusout", this.focusChanged);
    }
  }
}
